module.exports = __webpack_public_path__ + "static/media/add-token.965f8139.png";